// 定点巡检 类型
import React, { useEffect, useState, useRef } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import {
  PlusOutlined, SearchOutlined, MenuOutlined, DeleteOutlined, SettingOutlined, ExclamationCircleOutlined,
  ImportOutlined, EditOutlined, CaretRightOutlined, NodeCollapseOutlined, ExclamationCircleFilled, DownloadOutlined, CheckCircleOutlined,
  QuestionCircleOutlined
} from '@ant-design/icons';

import dayjs from 'dayjs';
import { Card, Button, Dropdown, Input, Space, Table, message as AntMessage, Pagination, Tag, Drawer, Form, theme, Select, App, Modal, Popconfirm, Switch } from 'antd';
import { GetRoutesList, ImportPoint, ImportRoute, DelRoutes, SetRoutes, AirTemporary, TakeoffAltitude, M3Temporary, IdentifyStakeFun, ExportWaypointsFun, downloadRouteApi } from '@/server/fixedPoint/list.js'
import { getDockElectricityApi } from '@/server/home.js'
import { basicPath } from '@/router/config';//引入路由基础路径
import './index.css'
const { TextArea } = Input;

function ShippingLine () {
  const navigate = useNavigate()
  const {
    token: { colorTextPlaceholder, colorPrimary, colorText },
  } = theme.useToken(); //获取主题颜色
  const [messageApi, contextHolder] = AntMessage.useMessage();
  const { message, modal } = App.useApp();
  const { confirm } = modal;


  //type 1 常规巡检 2 高危巡检 3 采集读数
  const location = useLocation();//接受传值数据
  const token = localStorage.getItem('dock_token');
  const [loading, setLoading] = useState(false);

  //表格筛选条件
  const [search, setSearch] = useState({
    access_token: token,
    type: -1,
    page: 1,
    perpage: 10,
  });
  const [cur, setCur] = useState(1);//当前页
  const [page, setPage] = useState(10);//每页多少条
  const [total, setTotal] = useState(0);//总条数
  const [AirportPermissionsArrName, setAirportPermissionsArrName] = useState([])//权限name
  const searchInput = useRef(null);//搜索框数据
  const [data, setData] = useState([]);//表格数据
  const [choose_id, setChooseId] = useState('');//当前选择的管线id

  const [modal_show, setDrawerShow] = useState(false);//是否显示弹窗
  const [modal_title, setModalTitle] = useState('新增');//弹窗标题
  const [relatedImg, setRelatedImg] = useState(false)//新增-是否关联图片
  const [form] = Form.useForm();
  const [btn_loading, setBtnLoading] = useState(false);//按钮加载

  const [airfield_list, setAirfieldList] = useState([{ value: '1', name: '机场1' }, { value: '2', name: '机场2' }]);//机场数据

  const [dockNameType, setDockNameType] = useState([])
  const ws = useRef(null);//ws 对象
  const hasAirList = useRef(false)//机场是否在线

  const [showMasked, setShowMasked] = useState(false);//显示蒙层

  //下载文件弹窗参数
  const [downloadModel, setDownloadModel] = useState({
    isOpen: false,
    title: '',
    content: '',
    id: '',
    url: '',//下载的链接
    list: {},
  });

  //表格头搜索框
  const SearchProps = (dataIndex, text) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      <div style={{ padding: 8, }} onKeyDown={(e) => e.stopPropagation()} >
        <Input
          ref={searchInput}
          placeholder={`搜索 ${text}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(confirm)} //回车搜索
          style={{ marginBottom: 8, display: 'block', }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(confirm)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90, }}
          >
            Search
          </Button>
          <Button
            onClick={() => handleReset(clearFilters, confirm)}
            size="small"
            style={{ width: 90, }}
          >
            Reset
          </Button>

        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? '#1890ff' : undefined,
        }}
      />
    ),//图标
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);//自动获得焦点
      }
    },
  });

  //表格头
  const columns = [
    // {
    //   title: '类型',
    //   dataIndex: 'title',
    //   render: (text, record) => {
    //     return (
    //       <div>{text}</div>
    //     )
    //   },
    //   // ...SearchProps('title', '航线名称'),
    // },
    {
      title: 'ID',
      dataIndex: 'id',
      // sorter: () => { },
    },
    {
      title: '航线名称',
      dataIndex: 'title',
      render: (text, record) => {
        return (
          <div>{text}</div>
        )
      },
      // ...SearchProps('title', '航线名称'),
    },
    {
      title: '机场',
      dataIndex: 'dock_id',
      render: (text, record) => {
        let showtext = dockNameType.find(res => res.value === text)?.text
        return (
          showtext
            ? <div>{showtext}</div>
            : record.category_id === 4
              ? (<div style={{ color: colorTextPlaceholder }}>-</div>)
              : (
                <Tag color="error">
                  未找到
                </Tag>
              )
        )
      },
      filters: dockNameType,
      filterMultiple: false,
    },
    // {
    //   title: '总里程(km)',
    //   dataIndex: 'length',
    //   sorter: () => { },
    // },
    {
      title: '最新执行时间',
      dataIndex: 'time',
      render: (text, record) => {
        return text
          ? (
            <div>
              <span className='marR8'>{text.substring(0, 10)}</span>
              <span className='opa45'>{text.substring(11, 16)}</span>
            </div>
          )
          : <div style={{ color: colorTextPlaceholder }}>-</div>
      },
      sorter: () => { },
    },
    {
      title: '关联图片',
      dataIndex: 'category_id',
      render: (text, record) => {
        return (
          text === 4
            ? (<span><CheckCircleOutlined style={{ color: '#6ABE39' }} /></span>)
            : <div style={{ color: colorTextPlaceholder }}>-</div>
        )
      },
      // sorter: () => { },
    },
    {
      title: '编辑人',
      dataIndex: 'username',
      render: (text, record) => {
        return (
          text
            ? (<span className='opa45'>{text}</span>)
            : <div style={{ color: colorTextPlaceholder }}>-</div>
        )
      },
      // sorter: () => { },
    },
    {
      title: '编辑时间',
      dataIndex: 'update_time',
      render: (text, record) => {
        return text
          ? (
            <div>
              <span className='opa45 marR8'>{text.substring(0, 10)}</span>
              <span className='opa45'>{text.substring(11, 16)}</span>
            </div>
          )
          : <div style={{ color: colorTextPlaceholder }}>-</div>
      },
      // sorter: () => { },
    },
    {
      title: '风险设置',
      dataIndex: 'dock_id',
      width: 100,
      align: 'center',
      render: (text, record) => {
        if (AirportPermissionsArrName.indexOf(`Risk_setting_${search.type}`) > -1) {
          return (
            <div onClick={() => { navigate('/fixedPoint_list_riskSet', { state: { list: record, search: search } }) }}            >
              <SettingOutlined className='pointer' style={{ width: '16px', height: '16px', color: colorPrimary }} />
            </div>
          )
        } else {
          return (<SettingOutlined style={{ width: '16px', height: '16px', color: colorText }} />)
        }
      },
    },
    {
      title: '操作',
      dataIndex: '',
      align: 'center',
      width: 120,
      render: (text, record) => {
        return (
          <Dropdown
            trigger={['click']}
            menu={dropDownOption(record)}
            placement="bottom"
          >
            <MenuOutlined className='pointer col_primary' />
          </Dropdown>
        )
      }
    },
  ];

  //表格操作列表
  const dropDownOption = (data) => {
    const typeArr = [
      {
        key: 4,
        permissions: AirportPermissionsArrName.indexOf(`Temporary_${search.type}`) > -1 && data.category_id !== 4,
        label: (
          <div onClick={() => {
            let restartDockArr = JSON.parse(localStorage.getItem('dock_restartDockArr')) || []
            if (restartDockArr?.find(e => e.dockId === data.dock_id)?.time && (dayjs().valueOf() - restartDockArr?.find(e => e.dockId === data.dock_id)?.time) < (120 * 1000)) {
              message.warning('当前机场重启小于两分钟，请稍等片刻')
            } else {
              getDockElectricity(data);
            }
          }}>
            <CaretRightOutlined className='marR10' /> 临时执行
          </div>
        ),
      },
      {
        key: 2,
        permissions: AirportPermissionsArrName.indexOf(`RoutesPoint_Import_${search.type}`) > -1 && data.category_id !== 4,
        label: (
          <div onClick={() => {
            setChooseId(data.id);
            document.getElementById('importPoint').click();
          }}>
            <NodeCollapseOutlined className='marR10' /> 上传管线
          </div>
        ),
      },
      {
        key: 3,
        permissions: AirportPermissionsArrName.indexOf(`RoutesRoute_Import_${search.type}`) > -1 && data.category_id !== 4,
        label: (
          <div onClick={() => {
            setChooseId(data.id);
            document.getElementById('importRoute').click();
          }}>
            <ImportOutlined className='marR10' /> 导入航线文件
          </div>
        ),
      },
      {
        key: 6,
        permissions: AirportPermissionsArrName.indexOf(`Wayfile_Export_${search.type}`) > -1 && data.category_id !== 4,
        label: (
          <div onClick={() => { downloadRoute(data) }}>
            <DownloadOutlined className='marR10' /> 下载航线文件
          </div>
        ),
      },
      {
        key: 1,
        permissions: AirportPermissionsArrName.indexOf(`RoutesInfo_Edit_${search.type}`) > -1,
        label: (
          <div onClick={() => {
            setChooseId(data.id);
            setDrawerShow(true);
            setModalTitle('编辑');
            setRelatedImg(data.category_id === 4)
            form.setFieldsValue({
              title: data.title,
              des: data.des,
              dock_id: dockNameType.find(res => res.value === data.dock_id)?.text ? data.dock_id : `原机场ID为:${data.dock_id}`,
            }); //表单赋值
          }}>
            <EditOutlined className='marR10' /> 修改
          </div>
        ),
      },
      {
        key: 5,
        permissions: AirportPermissionsArrName.indexOf(`RoutesInfo_Del_${search.type}`) > -1,
        label: (
          <div>
            <Popconfirm
              title="是否删除？"
              icon={
                <QuestionCircleOutlined
                  style={{ color: 'red', }}
                />
              }
              onConfirm={async () => {
                await DelRoutesFun(data.id)
              }}
              onCancel={() => { }}
              okText="删除"
              cancelText="取消"
            >
              <DeleteOutlined className='marR10' /> 删除
            </Popconfirm>
          </div>
        ),
      },
    ]
    // 下拉列表只能使用 items
    let arr = []
    for (let i = 0; i < typeArr.length; i++) {
      let item = typeArr[i];
      if (item.permissions) {
        if (item.key === 1 && data.category_id !== 4) { arr.push({ type: 'divider' }); }
        arr.push(item);
        if (item.key === 4 && typeArr[i + 1].key !== 1) { arr.push({ type: 'divider' }); continue }
      }
    }
    return { items: arr }
  }

  // 下载航线文件
  const downloadRoute = async (list) => {
    let dow = downloadModel
    let res = await downloadRouteApi({
      access_token: token,
      id: list.id,
      type: search.type,
    })
    if (res.ret !== 200) {
      dow.isOpen = false
      setDownloadModel({ ...dow })
      message.warning(res.msg || '下载航线文件失败，请稍后重试~')
      return
    }
    dow.isOpen = true
    dow.title = '下载航线文件'
    dow.content = '航线文件已准备，点击按钮下载'
    dow.id = list.id
    dow.url = res.data
    dow.list = list
    setDownloadModel({ ...dow })
  }

  //关闭下载弹窗
  const closeDownloadModel = () => {
    let info = { ...downloadModel };
    info.isOpen = false;
    setDownloadModel(info);
  }

  // //下载标识桩模板 type:下载方式 1、下载 2、另存为
  const downloadStakeTemplate = (type = 1) => {
    if (type === 1) {
      const x = new window.XMLHttpRequest();
      x.open('GET', downloadModel.url, true);
      x.responseType = 'blob';
      x.onload = () => {
        const url = window.URL.createObjectURL(x.response);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${downloadModel.list.title}.kmz`
        a.click();
        URL.revokeObjectURL(a.href)
      };
      x.send();

      let dow = downloadModel
      dow.isOpen = false
      setDownloadModel({ ...dow })
    }

    if (type === 2) {
      urlToFile(downloadModel.url).then(file => {
        saveAs(file, downloadModel.list.title)
      }).catch(error => {
        message.warning('获取文件地址失败，请联系管理员')
      })
    }
  }

  //另存为
  const saveAs = async (file, fileName) => {
    try {
      const opts = {
        types: [
          {
            description: '文件',
            accept: {
              'application/vnd.google-earth.kmz': ['.kmz']
            },
          }
        ],
        suggestedName: fileName,
        excludeAcceptAllOption: true
      };
      const handle = await window.showSaveFilePicker(opts); // 打开保存文件对话框
      const writable = await handle.createWritable(); // 创建可写入的文件对象

      // 在这里写入文件内容
      await writable.write(file)
      await writable.close()
      let dow = downloadModel
      dow.isOpen = false
      setDownloadModel({ ...dow })
      message.success('文件保存成功')
    } catch (error) {
      let text = JSON.stringify(error);
      if (text.indexOf('The user aborted a request') === -1) {//无法使用另存为
        message.warning('当前浏览器暂不支持另存为操作，请直接下载 或更换以下浏览器：谷歌、edge、360');
      }
    }
  }

  //地址转文件
  const urlToFile = (url) => {
    return new Promise((resolve, reject) => {
      var blob = null;
      var xhr = new XMLHttpRequest();
      xhr.open("GET", url);
      xhr.setRequestHeader('Accept', 'application/msword');
      xhr.responseType = "blob";
      // 加载时处理
      xhr.onload = () => {
        // 获取返回结果
        blob = xhr.response;
        let file = new File([blob], 'xxx', { type: 'application/msword' });
        // 返回结果
        resolve(file);
      };
      xhr.onerror = (e) => {
        message.warning('文件转换失败');
        reject(e)
      };
      // 发送
      xhr.send();
    });
  }

  //输入框搜索
  const handleSearch = (confirm) => {
    confirm()
  };

  //重置
  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    confirm();
  };

  //获取表格数据
  const getTableData = async (obj) => {
    setLoading(true);
    let res = await GetRoutesList(obj);
    if (res.ret !== 200) {
      message.warning(res.msg || '服务器开了小差，请重试');
      return;
    }
    let arr = res.data.items.length > 0 ? res.data.items.map((item) => {
      return {
        ...item, dock_id: Number(item.dock_id)
      }
    }) : [];
    setData(arr);
    setTotal(res.data.total);

    let dictionary = res.data?.sjzd?.map((item) => {
      return {
        label: item.name,
        value: Number(item.id),
      }
    });

    let dock = res.data?.sjzd?.map((item) => {
      return {
        text: item.name,
        value: Number(item.id),
      }
    });

    setDockNameType(dock)
    setAirfieldList(dictionary)
    setLoading(false);
  }

  //新增|修改管线
  const onFinish = async (values) => {
    console.log('values', values);
    setBtnLoading(true);
    let obj = {
      // ...values,
      des: values.des,
      type: search.type,
      access_token: token,
      title: values.title,
      dock_id: relatedImg ? undefined : values.dock_id,
      category_id: relatedImg ? 4 : undefined,
      id: choose_id ? choose_id : undefined,
    }
    let res = await SetRoutes(obj);
    setBtnLoading(false);
    if (res.ret !== 200) {
      message.warning(res.msg || '服务器开了小差，请重试');
      return;
    }
    message.success(choose_id ? '编辑成功' : '新增成功');
    CloseDrawer();
    getTableData(search);
  };

  //临时执行
  const TemporaryFun = async (id) => {
    try {
      let obj = {
        access_token: token,
        id: id
      }
      let res = null;
      setShowMasked(true);
      if (localStorage.getItem('dock_companyType') === '1') {
        messageApi.open({
          type: 'loading',
          content: '正在准备临时执行...',
          duration: 0,
        });
        res = await M3Temporary(obj)
        setShowMasked(false);
      } else if (localStorage.getItem('dock_companyType') === '2') {
        messageApi.open({
          type: 'loading',
          content: '正在准备临时执行...',
          duration: 0,
        });
        res = await AirTemporary(obj)
        setShowMasked(false);
      } else {
        message.warning('暂未获取到当前角色所在公司')
        return
      }
      messageApi.destroy();
      if (res.ret !== 200) {
        message.warning(res.msg || '服务器开了小差，请重试');
        return;
      }
      message.success('执行成功');
      getTableData(search);
    } catch (err) {
      message.warning('执行失败');
      messageApi.destroy();
    }
  }

  //删除
  const DelRoutesFun = async (id) => {
    let res = await DelRoutes({
      access_token: token,
      id: id
    })
    if (res.ret !== 200) {
      message.warning(res.msg || '服务器开了小差，请重试');
      return;
    }
    if (total > 10 && total % 2 === 1 && search.page > 1) {
      let num = search
      num.page = num.page - 1
      setSearch({ ...num })
      setCur(num - 1)
    }
    message.success('删除成功');
    getTableData(search);
  }

  //关闭弹窗
  const CloseDrawer = () => {
    setDrawerShow(false)
    form.resetFields();
    setChooseId('');
    setRelatedImg(false)
  }

  //上传坐标
  const importData = async (val) => {
    try {
      let obj = {
        access_token: token,
        id: val.id,
        type: '',//WGS84 GCJ
        file: val.file,
      }
      messageApi.open({
        type: 'loading',
        content: '正在上传管线...',
        duration: 0,
      });
      setShowMasked(true);
      const res = await ImportPoint(obj);
      setShowMasked(false);
      document.getElementById('importPoint').value = '';
      messageApi.destroy();
      if (res.ret !== 200) {
        message.warning(res.msg || '服务器开了小差，请重试');
        return;
      }
      message.success('上传成功');
      getTableData(search);
    } catch (err) {
      message.warning('上传失败');
      setShowMasked(false);
      messageApi.destroy();
    }
  };

  //上传航线
  const importRouteData = async (val) => {
    try {
      let obj = {
        access_token: token,
        id: val.id,
        type: search.type,
        file: val.file,
      }
      messageApi.open({
        type: 'loading',
        content: '正在导入航线文件...',
        duration: 0,
      });
      setShowMasked(true);
      const res = await ImportRoute(obj);
      setShowMasked(false);
      messageApi.destroy();
      document.getElementById('importRoute').value = '';
      if (res.ret !== 200) {
        message.warning(res.msg || '服务器开了小差，请重试');
        return;
      }
      message.success('上传成功');
      getTableData(search);
    } catch (err) {
      message.warning('上传超时，文件上传失败');
      setShowMasked(false);
      messageApi.destroy();
    }
  }

  //上传标识桩
  const importIdentifyStake = async (val) => {
    // var data = new FormData();
    // // 创建一个表单数据
    // data.append("access_token", token);
    // data.append("id", val.id);
    // data.append("file", val.file);
    let res = await IdentifyStakeFun({
      access_token: token,
      id: val.id,
      file: val.file
    });
    document.getElementById('identifyStake').value = '';
    if (res.ret !== 200) {
      message.warning(res.msg || '系统出错了');
      return;
    }
    message.success('上传成功');
    getTableData(search);
  };

  //导出管线、航点、标识桩
  const exportData = async (type, id) => {
    let res = await ExportWaypointsFun({
      access_token: token,
      id: id,
      type: type
    });
    if (res.ret !== 200) {
      message.warning(res.msg || '导出失败，请稍后重试~');
      return;
    }
    const link = document.createElement('a');
    link.style.display = 'none';
    link.href = res.data
    document.body.appendChild(link);
    link.click();
    // 释放的 URL 对象以及移除 a 标签
    URL.revokeObjectURL(link.href);
    document.body.removeChild(link);
    message.success('导出成功~')
  }

  const getAirportLive = async (url, dockSn) => { //机场是否在线
    let obj = {}
    let airTime = 1
    let airNum = 1
    ws.current = new WebSocket(url);

    ws.current.onopen = (msg) => {//链接开启
    };

    ws.current.onmessage = e => {// 成功获取数据
      try {
        setTimeout(() => {
          setLoading(false)
        }, 1000);
        let data = JSON.parse(e.data)

        if (data.biz_code === 'dock_osd' && data.data.sn === dockSn) {//机场
          airTime = dayjs().valueOf()
          if (data.data.host && JSON.stringify(data.data.host) !== '{}') {
            hasAirList.current = true
            return true
          }
          if (airNum === 1 && obj.longitude) {
            airNum += 1
          }
        }
      } catch (error) {
        // message.warning('当前机场状态错误，请确认机场是否正确链接')
      }
    }

    ws.current.onerror = (msg) => {//报错信息
      // console.log('链接出错', msg)
    }

    ws.current.onclose = (msg) => {//链接断开
      console.log('链接断开');
      if (ws.current) {
        ws.current.close()
        ws.current = null
      }
      airNum = 1
      clearInterval(settime)
      return false
    };
    // 3秒一次检查当前ws传回来的数据是否还在
    let settime = setInterval(() => {
      let airTimes = Math.abs(Math.floor(dayjs().valueOf() - airTime) / 1000)
      if (airTimes > 3) { return false } else { return true }
    }, 2000);
  }

  //获取机场电量
  const getDockElectricity = async (data) => {
    setLoading(true)
    if (ws.current) {
      ws.current.close()
      ws.current = null
    }
    let params = {
      access_token: token,
      dock_id: data.dock_id
    }
    let res = await getDockElectricityApi(params);
    if (res.ret !== 200) {
      message.warning(res.msg || '数据跑丢了~');
      setLoading(false);
      return;
    }

    if (!res.data.ws_host || !res.data.dockSn) {
      message.warning('暂未获取到ws地址或机场编号');
      setLoading(false)
      return;
    }

    let isLive = await getAirportLive(res.data.ws_host, res.data.dockSn)

    setTimeout(() => {
      if (isLive || hasAirList.current) {//机场是否存在
        setLoading(false)
        confirm({
          title: data.title,
          icon: <ExclamationCircleFilled />,
          content: '当前无人机电量为' + res.data.battery_percent + '%，是否起飞',
          onOk () {
            TemporaryFun(data.id);
            if (ws.current) {
              ws.current.close()
              ws.current = null
            }
          },
          onCancel () {
            if (ws.current) {
              ws.current.close()
              ws.current = null
            }
          }
        });
      } else {
        setLoading(false)
        confirm({
          title: '电量提醒',
          icon: <ExclamationCircleFilled />,
          content: `当前无人机电量为${res.data.battery_percent}%且3s内未获取到机场信息，是否起飞`,
          okText: '已确认机场开启，可以起飞',
          onOk () {
            TemporaryFun(data.id);
            if (ws.current) {
              ws.current.close()
              ws.current = null
            }
          },
          onCancel () {
            if (ws.current) {
              ws.current.close()
              ws.current = null
            }
          }
        });
      }
    }, 3000);

  }

  useEffect(() => {// 根据url地址确定当前属于哪个类型的记录
    let obj = { ...search };
    switch (location.pathname) {
      case '/fixedPoint_list_electricTower'://电塔巡检
        obj.type = 8;
        obj.page = 1
        break;
      case '/fixedPoint_list_station'://场站
        obj.type = 9;
        obj.page = 1
        break;
      default:
        break;
    }

    setSearch({ ...obj });
    getTableData(obj);
    setAirportPermissionsArrName(localStorage.getItem('dock_AirportPermissionsArrName') ? [...JSON.parse(localStorage.getItem('dock_AirportPermissionsArrName'))] : [])
    //eslint-disable-next-line
  }, [location.pathname])

  return (
    <>
      {contextHolder}
      <Card style={{ border: 0 }} className="mar24" styles={{ body: { padding: '24px' } }}>
        <div className="flex jcsb pdRL12 pdB16 align_center">
          <div className="fs16 fw500 col_main_text marR12">航线列表</div>
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => {
              if (AirportPermissionsArrName.indexOf(`RoutesInfo_Add_${search.type}`) > -1) {
                setChooseId('');
                setDrawerShow(true);
                setModalTitle('新增');
                setRelatedImg(false)
                form.setFieldsValue({
                  dock_id: airfield_list.length > 0 ? airfield_list[0].value : null
                });
              } else {
                message.warning('暂无权限！')
              }
            }}
          >
            新增
          </Button>
        </div>
        <Table
          columns={columns}
          dataSource={data}
          pagination={false}
          loading={loading}
          rowKey='id'
          onChange={(pagination, filters, sorter) => {
            let obj = { ...search };
            obj.page = 1;
            setCur(1);
            if (sorter && sorter.order) {
              let text = sorter.field + ' ';
              let ord = sorter.order === 'ascend' ? 'ASC' : 'DESC';
              obj.order = text + ord;
            } else {
              obj.order = '';
            }
            for (let i in filters) {
              let val = filters[i];
              if (val) {
                obj[i] = filters[i].join(',');
              } else {
                obj[i] = ''
              }
            }
            setSearch({ ...obj });
            getTableData({ ...obj })
          }}
        >
        </Table>

        <div className='pdT16'>
          <Pagination align='end' current={search.page} pageSize={search.perpage} total={total} showTotal={total => `共 ${total} 条数据`}
            onChange={
              (current, pageSize) => { //选择当前页后执行
                setCur(current);
                setPage(pageSize);
                let obj = { ...search };
                obj.perpage = pageSize;
                obj.page = current;
                setSearch({ ...obj });
                getTableData(obj);
              }
            } />
        </div>

        {/* 新增|编辑 弹窗 */}
        <Drawer
          title={modal_title}
          open={modal_show}
          width={256}
          footer={null}
          maskClosable={false}
          onClose={CloseDrawer}
          extra={
            <Button
              type='primary'
              onClick={() => { document.getElementById('DrawerSubmit').click() }}
            >
              提交
            </Button>
          }
        >
          <Form form={form} name='form' layout="vertical" onFinish={onFinish} style={{ marginTop: '12px' }}>

            <Form.Item style={{ display: modal_title === '新增' ? `` : `none` }} label="关联图片" name="relatedImg">
              <Switch value={relatedImg} onChange={(e) => { setRelatedImg(e) }} />
            </Form.Item>

            <Form.Item label="航线名称" name="title" rules={[{ required: true, message: '请输入单元名称', }, { pattern: /^.{0,20}$/, message: '名称不能超过20字符', }]}>
              <Input placeholder="-" />
            </Form.Item>

            <Form.Item style={{ display: !relatedImg ? `` : `none` }} label="机场" name="dock_id" rules={[{ required: true, message: '请选择机场', }]}>
              <Select style={{ width: '100%', }} options={airfield_list} />
            </Form.Item>

            <Form.Item label="描述" name="des" rules={[{ required: true, message: '请输入管线描述', }]}>
              <TextArea placeholder="-" />
            </Form.Item>


            <Button id='DrawerSubmit' type="primary" className='none' htmlType="submit" loading={btn_loading}>
              确定
            </Button>
          </Form>
        </Drawer>

        {/* 蒙层 */}
        <Drawer open={showMasked} width={0} footer={null} maskClosable={false}>
        </Drawer>

        <input id="importPoint" type="file" accept=".xls,.xlsx" hidden={true} onChange={(e) => {
          importData({ id: choose_id, file: e.target.files[0] })
        }}
        />
        <input id="importRoute" type="file" accept=".kmz," hidden={true} onChange={(e) => {
          importRouteData({ id: choose_id, file: e.target.files[0] })
        }}
        />
        {/* 上传标识桩 */}
        <input id="identifyStake" type="file" accept=".xls,.xlsx" hidden={true} onChange={(e) => {
          importIdentifyStake({ id: choose_id, file: e.target.files[0] })
        }}
        />
        <>{/* 下载航线文件 */}
          <Modal title="" width={416} open={downloadModel.isOpen}
            footer={false} closable={false} maskClosable={true}
            onCancel={() => { closeDownloadModel() }}
          >

            <div className='marB8 flex_row align_center'>
              <span className='fs22 marR16 col_primary'><ExclamationCircleOutlined /></span>
              <span style={{ fontWeight: 500, fontSize: 16, color: 'rgba(255, 255, 255, 0.85)' }}>
                {downloadModel.title}
              </span>
            </div>
            <div className='fs14 marL38' style={{ fontSize: 14, color: 'rgba(255, 255, 255, 0.85)' }}>
              {downloadModel.content}
            </div>

            <div className='marT24 tr'>
              <Button className='marR8' onClick={() => {
                closeDownloadModel()
              }}>取消</Button>

              <Button className='marR8' type="primary" onClick={() => {
                downloadStakeTemplate(1);
              }}>下载</Button>

              <Button type="primary" onClick={() => {
                downloadStakeTemplate(2);
              }}>另存为</Button>
            </div>
          </Modal>
        </>
      </Card >
    </>
  )
}
export default ShippingLine